import Colors from '@constants/Colors';
import { Cancel01Icon, PlusSignIcon } from '@hugeicons/core-free-icons';
import { ViewMode } from '@molecules/ListCalendarViewToggle';
import { EventsCalendarDisplay } from '@organisms/EventsCalendarDisplay';
import PublicEventsCardList from '@organisms/PublicEventsCardList';
import { withAuthGate } from '@sunrise-ui/composites';
import {
  IconButton,
  menuContentStyle,
  useDynamicStyles,
  useSafeLocalSearchParams,
  type WithResponsive,
} from '@sunrise-ui/primitives';
import { router } from 'expo-router';
import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Menu } from 'react-native-paper';

function EventsScreen() {
  const styles = useDynamicStyles(createStyles);
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const { view = ViewMode.LIST } = useSafeLocalSearchParams<{
    view?: ViewMode;
  }>();
  const toggleMenuVisibility = () => {
    setIsMenuVisible(!isMenuVisible);
  };

  const closeMenu = () => {
    setIsMenuVisible(false);
  };

  const handleStartMeeting = () => {
    closeMenu();
    router.navigate('/greenRoom');
  };

  const handleScheduleMeeting = () => {
    closeMenu();
    router.navigate('/events/schedule');
  };

  const handleSuggestTopic = () => {
    closeMenu();
    router.navigate('/events/suggest');
  };

  return (
    <View style={styles.container}>
      {view === 'calendar' ? (
        <EventsCalendarDisplay />
      ) : (
        <PublicEventsCardList />
      )}
      <View style={styles.outerMenuContainer}>
        <Menu
          visible={isMenuVisible}
          onDismiss={closeMenu}
          style={styles.menu}
          contentStyle={menuContentStyle}
          anchor={
            <IconButton
              icon={isMenuVisible ? Cancel01Icon : PlusSignIcon}
              onPress={toggleMenuVisibility}
              style={styles.addButton}
              size="medium"
            />
          }
        >
          <Menu.Item onPress={handleSuggestTopic} title="Suggest Topic" />
          <Menu.Item onPress={handleScheduleMeeting} title="Schedule Meeting" />
          <Menu.Item onPress={handleStartMeeting} title="Start Meeting" />
        </Menu>
      </View>
    </View>
  );
}

const createStyles = ({ isMobile, isTablet }: WithResponsive) =>
  StyleSheet.create({
    container: {
      width: '100%',
      flex: 1,
      justifyContent: 'space-between',
    },
    outerMenuContainer: {
      display: 'none',
      position: 'absolute',
      margin: isMobile ? 12 : isTablet ? 16 : 20,
      right: 0,
      bottom: 0,
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
    menu: {
      marginTop: isMobile ? -135 : -155,
    },
    addButton: {
      backgroundColor: Colors.dark.purple1,
    },
  });

export default withAuthGate(EventsScreen);
